import React from 'react';

interface EyeIconProps {
  height?: number | string;
  width?: number | string;
  active?: boolean;
}

const SweepIcon: React.FC<EyeIconProps> = ({
  height = 39.691,
  width = 60,
  active = false,
}) => {
  const strokeColor = active ? '#141740' : '#9C9CC9';

  return (
    <svg
      id="Group_116625"
      data-name="Group 116625"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 60 39.691"
    >
      <g id="Group_116345" data-name="Group 116345" transform="translate(0 0)">
        <g
          id="Path_110155"
          data-name="Path 110155"
          transform="translate(2)"
          fill="none"
        >
          <path
            d="M28,0C41.807,0,51.276,10.6,58,19.846c-7.23,9.94-16.193,19.846-30,19.846S3.985,28.075-2,19.846C3.9,11.74,14.193,0,28,0Z"
            stroke="none"
          />
          <path
            d="M 28 2 C 25.015 2 22.012 2.61 19.074 3.812 C 16.462 4.881 13.836 6.444 11.267 8.457 C 7.628 11.309 4.093 15.043 0.487 19.846 C 4.121 24.689 7.668 28.438 11.299 31.279 C 13.858 33.282 16.477 34.835 19.083 35.895 C 22.012 37.087 25.012 37.691 28 37.691 C 33.839 37.691 39.155 35.799 44.253 31.907 C 48.781 28.449 52.589 23.79 55.518 19.847 C 52.847 16.262 49.029 11.584 44.435 8.04 C 41.961 6.132 39.407 4.66 36.844 3.665 C 33.995 2.56 31.019 2 28 2 Z M 28 0 C 41.807 0 51.276 10.601 58 19.846 C 50.77 29.786 41.807 39.691 28 39.691 C 14.193 39.691 3.985 28.075 -2 19.846 C 3.895 11.74 14.193 0 28 0 Z"
            stroke="none"
            fill={strokeColor}
          />
        </g>
        <g
          id="Ellipse_3748"
          data-name="Ellipse 3748"
          transform="translate(15.942 5.788)"
          fill="none"
          stroke={strokeColor}
          strokeWidth="2"
        >
          <circle cx="14.058" cy="14.058" r="14.058" stroke="none" />
          <circle cx="14.058" cy="14.058" r="13.058" fill="none" />
        </g>
        <g
          id="Ellipse_3749"
          data-name="Ellipse 3749"
          transform="translate(24.067 13.912)"
          fill="none"
          stroke={strokeColor}
          strokeWidth="2"
        >
          <circle cx="5.933" cy="5.933" r="5.933" stroke="none" />
          <circle cx="5.933" cy="5.933" r="4.933" fill="none" />
        </g>
      </g>
    </svg>
  );
};

export default SweepIcon;
